import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const CandidateTableSummary = () => {
  const [candidateDetails, setCandidateDetails] = useState({});
  const { selectedCandidateInfo } = useSelector(
    (state) => state.interviewResponsesL1DashboardSliceReducer
  );

  return (
    <div class="box-main-bg" style={{ minHeight: "30.4rem" }}>
      <h4>
        Name: <span>{selectedCandidateInfo?.name}</span>
      </h4>
      <table class="box-table">
        <tr>
          <td>Highest Degree</td>
          <td> {selectedCandidateInfo?.higherEducation} </td>
        </tr>
        <tr>
          <td>Experience</td>
          <td> {selectedCandidateInfo?.totalExperience} </td>
        </tr>
        <tr>
          <td>Company</td>
          <td> {selectedCandidateInfo.organizationName} </td>
        </tr>
        <tr>
          <td>Designation</td>
          <td> {selectedCandidateInfo.designation} </td>
        </tr>
        <tr>
          <td>CTC</td>
          <td> {selectedCandidateInfo.currentCTC} </td>
        </tr>
        <tr>
          <td>Joining Time</td>
          <td> {selectedCandidateInfo.noticePeriod}</td>
        </tr>
        <tr>
          <td>Current Location</td>
          <td> {selectedCandidateInfo?.currentLocation} </td>
        </tr>
      </table>

      <ul className="socialbox-ul" style={{ textAlign: "start" }}>
        <li>
          <a
            href={candidateDetails["userSocialProfileDTO"]?.linkedInProfile}
            target="_blank"
            className="tooltipped linked-in"
            data-position="bottom"
            data-tooltip="LinkedIn Profile"
          ></a>
        </li>
        <li>
          <a
            href={`http://github.com/${
              candidateDetails["userSocialProfileDTO"]?.githubUsername ?? ""
            }`}
            target="_blank"
            className="tooltipped github"
            data-position="bottom"
            data-tooltip="GitHub"
          ></a>
        </li>
        <li>
          <a
            target="_blank"
            href={
              candidateDetails["userSocialProfileDTO"]?.stackOverflowProfile
            }
            className="tooltipped stackoverflow"
            data-position="bottom"
            data-tooltip="Stack Overflow"
          ></a>
        </li>
        <li>
          <a
            target="_blank"
            href={candidateDetails["userSocialProfileDTO"]?.resumeFile}
            className="tooltipped resume-ico"
            data-position="bottom"
            data-tooltip="CV"
          ></a>
        </li>
      </ul>
    </div>
  );
};

export default CandidateTableSummary;
